import React from "react";
import { Icon, Step } from "semantic-ui-react";

require("./BookingStepper.css");

interface BookingStepperProps {
  step: number;
  bookingDate?: any;
  bookingSlot?: any;
}

const BookingStepper = (props: BookingStepperProps) => {
  return (
    <div>
      <Step.Group unstackable className="stepper">
        <Step active={props.step === 1}>
          <Icon name="calendar alternate" />
          <Step.Content className="mobile hidden">
            <Step.Title>Choose date</Step.Title>
            <Step.Description>Choose an available date</Step.Description>
          </Step.Content>
        </Step>

        <Step active={props.step === 2} disabled={!props.bookingDate}>
          <Icon name="time" />
          <Step.Content className="mobile hidden">
            <Step.Title>Choose drop off time</Step.Title>
            <Step.Description>Select from available times</Step.Description>
          </Step.Content>
        </Step>

        <Step active={props.step === 3} disabled={!props.bookingSlot}>
          <Icon name="save" />
          <Step.Content className="mobile hidden">
            <Step.Title>Confirm Booking</Step.Title>
          </Step.Content>
        </Step>
      </Step.Group>
    </div>
  );
};

export default BookingStepper;
